import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { consts } from '../../../common/modals/consts';
import { HelpConsts } from "../../../help/models/help-consts";
import { OurUserService } from '../../../users/services/user.service';
import { IUserInfo } from '../../../users/models/userInfo.interface';
import { Subscription } from 'rxjs';
import { ErrorHandlingService } from '../../../services/error-handling.service';
import { CompanyService } from '../../../company/services/company.service';
import { AlertEmailOptions } from '../../../message-models/alert-email-options.class';
import { IAlertEmailOptions } from '../../../message-models/alert-email-options.interface';
import { ICompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.interface';
import { CompanyAlertEmailSettings } from '../../../message-models/company-alert-email-settings.class';

@Component({
  selector: 'app-company-settings-email-modal',
  templateUrl: './company-settings-email-modal.component.html',
  styleUrls: ['./company-settings-email-modal.component.scss']
})

export class CompanySettingsEmailModalComponent implements OnInit {

  @Input() isEditing = false;
  EmailAddRequest: FormData;
  @Input() headerText = 'Add Recipient Email';
  @Output() emaillAddSave: EventEmitter<FormData> = new EventEmitter<FormData>();
  @Output() modalClosed: EventEmitter<void> = new EventEmitter<void>();
  loggedInUserSubscription: Subscription;
  public loggedInUser: IUserInfo;
  public companyId: string = consts.emptyGuid;
  public emailOptions: Array<IAlertEmailOptions> = new Array<IAlertEmailOptions>();
  selectedEmailOptions: Array<CompanyAlertEmailSettings> = new Array<CompanyAlertEmailSettings>();
  isEmailModalLoading: boolean = false;

  constructor(public modalRef: DynamicDialogRef,
    private errorHandlingService: ErrorHandlingService,
    private userService: OurUserService,
    private companyService: CompanyService) { }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe(user => {
        this.updateUserAndReload(user);
        this.companyId = this.loggedInUser?.companyId;
      })
    }, () => {
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
    this.isEmailModalLoading = true;
    this.getAlertEmailOptionsList();
  }

  private updateUserAndReload(user: IUserInfo) {
      this.loggedInUser = user;
      this.companyId = this.loggedInUser?.companyId;
      if(this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
    }
  }

  getAlertEmailOptionsList() {
    this.companyService.getAlertEmailOptionsList(this.companyId).subscribe(results => {
      this.emailOptions = results;
      this.isEmailModalLoading = false;
    }, (error) => {
      console.log(error);
      this.errorHandlingService.showErrorWarning().subscribe(() => {
      });
    })
  }

  saveClicked() {
    this.isEmailModalLoading = true;
    this.emailOptions.forEach(item => {
      if (item.selected == true) {
        var selectedOption = new CompanyAlertEmailSettings();
        selectedOption.companySettingsId = consts.emptyGuid;
        selectedOption.companyId = this.companyId;
        selectedOption.email = item.email;
        selectedOption.personName = item.Name;
        this.selectedEmailOptions.push(selectedOption);
      }
    });
    console.log(this.selectedEmailOptions);
    this.companyService.addAlertEmail(this.selectedEmailOptions).subscribe(companyEmailSetting => {
      this.selectedEmailOptions = new Array<CompanyAlertEmailSettings>();
      this.isEmailModalLoading = false;
      this.modalRef.close();
      this.modalClosed.emit();
    })
  }

  cancelBtnClicked() {
    this.modalRef.close();
  }
}
